import React, { useContext, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router';
import Home from './pages/Home';
import { history, store } from './redux/store';
import { Provider } from 'react-redux';
import { HistoryRouter as Router } from "redux-first-history/rr6";
import './styles/index.css';
import Header from './components/Header';
import { IntlProvider } from 'react-intl';
import AppLocale from './i18n';
import { appGetLocale, appPathPrefix } from './helpers/appHelper';
import Language from './pages/Language';
import { postLogin } from './apis';
import { __DEV__ } from './helpers/simpleHelper';
import Footer from './components/Footer';
import News from './pages/News';
import Products from './pages/Products';
import Shops from './pages/Shops';
import Recruit from './pages/Recruit';
import Jobs from './pages/Jobs';
import JobsApplication from './pages/JobsApplication';
import AboutUs from './pages/AboutUs';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './config/config';
import { getAnalytics } from "firebase/analytics";


const App = () => {
    const appLanguage = React.createContext({ locale: appGetLocale()});
    const locale = useContext(appLanguage);
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    const prefix = appPathPrefix();
    const location = useLocation();
    const nav = useNavigate();

    useEffect(() => {
        postLogin();
    }, []);

    useEffect(() => {
        if(location.search==='?Route=CareerMaster/Index'){
            nav(prefix+'/careers');
        }
        else if (location.search==='?Route=Home/AboutUs'){
            nav(prefix+'/about_us');
        }
    }, [location]);

    return (
        <Provider store={store}>
            <Router history={history}>
                <IntlProvider locale={AppLocale[locale.locale].locale} messages={AppLocale[locale.locale].messages}>
                    <Header />
                    <Routes>
                        <Route path={prefix+"/"} element={<Home />} />
                        <Route path={prefix+"/language"} element={<Language />} />
                        <Route path={prefix+"/news"} element={<News />} />
                        <Route path={prefix+"/products"} element={<Products />} />
                        <Route path={prefix+"/stores"} element={<Shops />} />
                        <Route path={prefix+"/careers"} element={<Recruit />} />
                        <Route path={prefix+"/careers/:jobsNature"} element={<Jobs />} />
                        <Route path={prefix+"/careers/:jobsNature/application/:jobsId"} element={<JobsApplication />} />
                        <Route path={prefix+"/about_us"} element={<AboutUs />} />
                    </Routes>
                    {(window.location.pathname !== prefix+'/' && window.location.pathname !== prefix+'/stores' && window.location.pathname !== prefix+'/about_us') && <Footer />}
                </IntlProvider>
            </Router>
        </Provider>
    )
};

export default App;